import styles from '../Styles/HomePage.module.css';

function Home(){

    return <div className={styles.psevdoBody}>Скоро тут что-то будет</div>
};

export default Home;